import { gql, TypedDocumentNode } from "@apollo/client";

import { Run } from "types/generated";

type RetryRunData = {
  runRetry: Pick<Run, "id">;
};

type RetryRunVariables = {
  stackId: string;
  runId: string;
};

export const RETRY_RUN: TypedDocumentNode<RetryRunData, RetryRunVariables> = gql`
  mutation RetryMostRecentRunNext($stackId: ID!, $runId: ID!) {
    runRetry(stack: $stackId, run: $runId) {
      id
    }
  }
`;
